import React, { FC } from 'react';
import { Outlet } from 'react-router';

const Financing: FC = () => {
  return <Outlet />;
};

export default Financing;
